// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2WpXO","footer":"ModalFilter_footer__1N38-"};